<template>
  <div>
    <div class="top">
      <div class="title">
        浩顿洞察，解决您的商业难题
      </div>
      <div class="value">浩顿方案支持您产品生命周期各个阶段的商业决策</div>
    </div>
    <div class="detail">
      <div class="value" @click="toLocal('one')">
        <div class="icon"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/international/roadmapIcon1.png" alt=""></div>
        <div class="text" style="backgroundColor:#e95412">
          <div class="num" style="backgroundColor:#f39801">1</div>
          机会探索
        </div>
      </div>
      <div class="value" @click="toLocal('two')">
        <div class="icon"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/international/roadmapIcon2.png" alt=""></div>
        <div class="text" style="backgroundColor:#2180c4">
          <div class="num" style="backgroundColor:#5bacca">2</div>产品设计
        </div>
      </div>
      <div class="value" @click="toLocal('three')">
        <div class="icon"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/international/roadmapIcon3.png" alt=""></div>
        <div class="text" style="backgroundColor:#218f82">
          <div class="num" style="backgroundColor:#71bd73">3</div>市场沟通
        </div>
      </div>
      <div class="value" @click="toLocal('four')">
        <div class="icon"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/international/roadmapIcon4.png" alt=""></div>
        <div class="text" style="backgroundColor:#f39801">
          <div class="num" style="backgroundColor:#e95412">4</div>落地与跟踪
        </div>
      </div>
    </div>
    <div class="scheme d-none d-sm-block">
      <div class="title">浩顿方案</div>
      <div class="value">
        <div class="text" style="border: 2px solid #e95412;backgroundColor:#efefef">
          市场规模和差距分析</br>
          趋势和市场进入评估</br>
          预测和可行性评估</br>
          产品机会分析</br>
        </div>
        <div class="text" style="border: 2px solid #2180c4;backgroundColor:#efefef">
          功能和概念评估</br>
          用户偏好评估</br>
          用户U&A评估</br>
          痛点、需求和欲望评估</br>
          产品使用测试</br>
        </div>
        <div class="text" style="border: 2px solid #208f82;backgroundColor:#efefef">
          市场定位</br>
          定价测试</br>
          传播信息（视觉&文字）测试</br>
          传播渠道评估</br>

        </div>
        <div class="text" style="border: 2px solid #f29800;backgroundColor:#efefef">
          竞争格局分析</br>
          合规和监管评估</br>
          进入市场规则</br>
          可用性测试</br>

        </div>
      </div>

    </div>
    <div class="scheme d-none d-sm-block">
      <div class="title">商业决策</div>
      <div class="value">
        <div class="text" style="border: 2px solid #e95412;backgroundColor:#fae4d6">
          了解市场</br>
          识别挑战/障碍</br>
          发掘市场机会</br>
          指导选择优先项目</br>
          指导R&D</br>

        </div>
        <div class="text" style="border: 2px solid #2180c4;backgroundColor:#dce8f4">
          产品功能测试</br>
          优化产品设计</br>
          完善销售预测</br>
          分析/定位市场/目标客户群</br>

        </div>
        <div class="text" style="border: 2px solid #208f82;backgroundColor:#dfedd6">
          优化推广材料</br>
          完善传播策略</br>
          指导营销计划</br>

        </div>
        <div class="text" style="border: 2px solid #f29800;backgroundColor:#fbeecb">
          营销战略制定</br>
          品牌推广及效果评估</br>
          品牌表现评估及跟踪</br>

        </div>
      </div>

    </div>
    <!-- 手机端 -->
    <div class="mobilescheme d-block d-sm-none">
      <div class="value" id="one">
        <div class="mobiledetail">
          <div class="icon"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/international/roadmapIcon1.png" alt=""></div>
          <div class="text" style="backgroundColor:#e95412">
            <div class="num" style="backgroundColor:#f39801">1</div>
            机会探索
          </div>
        </div>
        <div class="plan" style="border: 2px solid #e95412;backgroundColor:#efefef">
          市场规模和差距分析</br>
          趋势和市场进入评估</br>
          预测和可行性评估</br>
          产品机会分析</br>
        </div>
        <div class="plan" style="border: 2px solid #e95412;backgroundColor:#fae4d6">
          了解市场</br>
          识别挑战/障碍</br>
          发掘市场机会</br>
          指导选择优先项目</br>
          指导R&D</br>
        </div>
      </div>

      <div class="value" id="two">
        <div class="mobiledetail">
          <div class="icon"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/international/roadmapIcon2.png" alt=""></div>
          <div class="text" style="backgroundColor:#2180c4">
            <div class="num" style="backgroundColor:#5bacca">2</div>产品设计
          </div>
        </div>
        <div class="plan" style="border: 2px solid #2180c4;backgroundColor:#efefef">
          功能和概念评估</br>
          用户偏好评估</br>
          用户U&A评估</br>
          痛点、需求和欲望评估</br>
          产品使用测试</br>
        </div>
        <div class="plan" style="border: 2px solid #2180c4;backgroundColor:#dce8f4">
          产品功能测试</br>
          优化产品设计</br>
          完善销售预测</br>
          分析/定位市场/目标客户群</br>
        </div>
      </div>

      <div class="value" id="three">
        <div class="mobiledetail">
          <div class="icon"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/international/roadmapIcon3.png" alt=""></div>
          <div class="text" style="backgroundColor:#218f82">
            <div class="num" style="backgroundColor:#71bd73">3</div>市场沟通
          </div>
        </div>
        <div class="plan" style="border: 2px solid #208f82;backgroundColor:#efefef">
          市场定位</br>
          定价测试</br>
          传播信息（视觉&文字）测试</br>
          传播渠道评估</br>
        </div>
        <div class="plan" style="border: 2px solid #208f82;backgroundColor:#dfedd6">
          优化推广材料</br>
          完善传播策略</br>
          指导营销计划</br>
        </div>
      </div>

      <div class="value" id="four">
        <div class="mobiledetail">
          <div class="icon"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/international/roadmapIcon4.png" alt=""></div>
          <div class="text" style="backgroundColor:#f39801">
            <div class="num" style="backgroundColor:#e95412">4</div>落地与跟踪
          </div>
        </div>
        <div class="plan" style="border: 2px solid #f29800;backgroundColor:#efefef">
          竞争格局分析</br>
          合规和监管评估</br>
          进入市场规则</br>
          可用性测试</br>
        </div>
        <div class="plan" style="border: 2px solid #f29800;backgroundColor:#fbeecb">
          营销战略制定</br>
          品牌推广及效果评估</br>
          品牌表现评估及跟踪</br>
        </div>
      </div>
    </div>
    <div class="end">
      您的产品目前在那个阶段？您遇到了那些商业难题或需求？</br>
     <el-button type="primary" round @click="$router.push('/cn/contact')">欢迎与我们交流!</el-button>
      
    </div>
  </div>
</template>

<script>
import {advertisementFlow} from "@/api/api"

export default {
  data() {
    return {};
  },
  methods: {
    toLocal(Id) {
      //查找存储的锚点id
      let toElement = document.getElementById(Id);
      //跳转
        toElement.scrollIntoView();
    },
      advertisementFlow() {
      // 如果没有source
      if (this.$route.query.source == undefined) {
        // console.log(1);
        // 就把source拼接
        advertisementFlow({
          path: "roadmap",
          source: "",
          information: "医疗器械创新路线图"
        }).then(res => {
          if (res.code == 10000) {
            // console.log(res);
          }
        });
        // 如果有source
      } else {
        advertisementFlow({
          path: "roadmap",
          source:this.$route.query.source,
          information: "医疗器械创新路线图"
        }).then(res => {
          if (res.code == 10000) {
            // console.log(res);
          }
        });
      }
    },
  }
};
</script>

<style lang="scss" scoped>
img {
  pointer-events: none;
}
.top {
  padding: 50px 120px;
  background-color: #a0c2ec;

  .title {
    color: #fff;
    font-size: 45px;
    font-weight: 700;
  }
  .value {
    color: #fff;
    text-align: center;
    // width: 80%;
    font-size: 25px;
    padding-top: 50px;
  }
}
.detail {
  padding: 60px 120px 20px 120px;
  display: flex;
  justify-content: space-between;
  .value {
    width: 25%;
    text-align: center;
    .icon {
      width: 80px;
      margin: 0 auto;
      img {
        width: 100%;
      }
    }
    .text {
      margin: 0 auto;
      width: 200px;
      font-size: 30px;
      margin-top: 30px;
      padding-bottom: 30px;
      border-radius: 80px;
      color: #fff;
      font-weight: 700;
      .num {
        font-weight: 400;
        //    border: 1px solid #000;
        width: 100px;
        height: 50px;
        margin: 0 auto;
        border-radius: 0 0 50% 50%;
        overflow: hidden;
      }
    }
  }
}
.scheme {
  padding: 0px 120px;
  .title {
    text-align: center;
    font-size: 30px;
    font-weight: 700;
  }
  .value {
    display: flex;
    justify-content: space-around;
    padding: 20px 0;
    .text {
      width: 23%;
      text-align: center;
      padding-top: 10px;
      border-radius: 20px;
      line-height: 30px;
    }
  }
}
.end {
  padding: 50px 120px 0;
  margin-bottom: 100px;
  text-align: center;
  font-size: 35px;
  font-weight: 700;
  button{
font-size: 35px;
margin-top: 20px;
text-align: center;
  }
}
@media screen and (max-width: 576px) {
  .top {
    .title {
      font-size: 80px;
    }
    .value {
      font-size: 70px;
    }
  }
  .detail {
    .value {
      .icon {
        width: 130px;
      }
      .text {
        font-size: 50px;
        width: 93%;
        .num {
          // font-size: 0px;
          height: 70px;
          width: 150px;
        }
      }
    }
  }
  .mobilescheme {
    padding: 50px 120px;
    text-align: center;
    .value {
      padding-top: 200px;
      .mobiledetail {
        .icon {
          width: 300px;
          height: 300px;
          margin: 0 auto;
          img {
            width: 100%;
          }
        }
        .text {
          .num {
            width: 300px;
            height: 120px;
            margin: 0 auto;
            border-radius: 0 0 50% 50%;
            margin-bottom: 20px;
          }
          font-size: 70px;
          color: #fff;
          width: 80%;
          margin: 0 auto;
          border-radius: 100px;
          padding-bottom: 50px;
          margin-top: 30px;
        }
      }
      .plan {
        font-size: 70px;
        line-height: 90px;
        padding: 50px;
        width: 80%;
        margin: 50px auto;
        border-radius: 50px;
      }
    }
  }
  .end {
    font-size: 60px;
    button{
      font-size: 60px;
    }
  }
}
</style>